export const getAppCommonData = async (api_route: string) => {
    const fetchData = async (url: string) => {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch data from ${url}`);
        }
        return response.json();
    };

    const [appdata, header, subfooter, footer] = await Promise.all([
        fetchData(`${api_route}/services/appdata`),
        fetchData(`${api_route}/presentation/get/pageHeader`),
        fetchData(`${api_route}/presentation/get/pageSubFooter`),
        fetchData(`${api_route}/presentation/get/pageFooter`),
    ]);

    return {
        appdata,
        layoutProps: {
            header,
            subfooter,
            footer,
        }
    }
}